import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

// ==================== Helper ====================

const buildQuery = (filters = {}) => {
  const params = new URLSearchParams();

  if (filters.search) params.append("search", filters.search);

  if (
    filters.isActive !== undefined &&
    filters.isActive !== ""
  ) {
    params.append("isActive", filters.isActive);
  }

  if (filters.page) params.append("page", filters.page);

  if (filters.limit) params.append("limit", filters.limit);

  return params.toString() ? `?${params.toString()}` : "";
};

// =======================================================
// OWNER (ADMIN)
// Base Route: /academic-years
// =======================================================

export const createAcademicYear = async (data) => {
  const res = await axiosInstance.post(
    "/academic-years/create",
    data
  );

  return res.data;
};

export const getAllAcademicYears = async (
  filters = {}
) => {
  const res = await axiosInstance.get(
    `/academic-years/all${buildQuery(filters)}`
  );

  return res.data;
};

export const getActiveAcademicYear = async () => {
  const res = await axiosInstance.get(
    "/academic-years/active"
  );

  return res.data;
};

export const getAcademicYearById = async (id) => {
  const res = await axiosInstance.get(
    `/academic-years/${id}`
  );

  return res.data;
};

export const updateAcademicYear = async (
  id,
  data
) => {
  const res = await axiosInstance.put(
    `/academic-years/update/${id}`,
    data
  );

  return res.data;
};

export const deleteAcademicYear = async (id) => {
  const res = await axiosInstance.delete(
    `/academic-years/delete/${id}`
  );

  return res.data;
};

export const markAsCurrentAcademicYear = async (
  id
) => {
  const res = await axiosInstance.put(
    `/academic-years/set-active/${id}`
  );

  return res.data;
};

// =======================================================
// STAFF PORTAL
// Base Route: /academic-year-portal
// =======================================================

export const createAcademicYearPortal = async (
  data
) => {
  const res = await axiosInstance.post(
    "/academic-year-portal/create",
    data
  );

  return res.data;
};

export const getAllAcademicYearsPortal =
  async (filters = {}) => {
    const res = await axiosInstance.get(
      `/academic-year-portal/all${buildQuery(filters)}`
    );

    return res.data;
  };

export const getActiveAcademicYearPortal =
  async () => {
    const res = await axiosInstance.get(
      "/academic-year-portal/active"
    );

    return res.data;
  };

export const getAcademicYearByIdPortal =
  async (id) => {
    const res = await axiosInstance.get(
      `/academic-year-portal/${id}`
    );

    return res.data;
  };

export const updateAcademicYearPortal =
  async (id, data) => {
    const res = await axiosInstance.put(
      `/academic-year-portal/update/${id}`,
      data
    );

    return res.data;
  };

export const setActiveAcademicYearPortal =
  async (id) => {
    const res = await axiosInstance.put(
      `/academic-year-portal/set-active/${id}`
    );

    return res.data;
  };